import React from 'react'
import { Form as FormikForm, FormikFormProps } from 'formik'

const Form = React.forwardRef<HTMLFormElement, FormikFormProps>(function Form(
  { children, ...props },
  ref
) {
  return (
    <FormikForm ref={ref} translate="yes" {...props}>
      {children}
    </FormikForm>
  )
})

export default Form
